<div class="pointCF__field">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField()?.label }}"
    [ppTrimTooltip]="true"
  >
    <img class="pointCF__bulk-changes-field-icon" [src]="EIconPath.CUSTOM_FIELD_COST_ACTIVITY" />

    <span class="pointCF__label-container">
      {{ ppCustomField()?.label }}
    </span>
  </label>

  <pp-custom-field-cost
    ppTooltip
    [ppTitle]="tooltipText"
    [ppCanEdit]="!ppCustomField().subValuesActive && !disabled"
    [ppWorkspaceId]="ppCustomField().workspaceId"
    [ppFieldId]="ppCustomField().id"
    [ppFieldLabel]="ppCustomField().label"
    [ppFieldCurrencySymbol]="ppCustomField().currencySymbol"
    [ppFieldCurrencyCode]="ppCustomField().currencyCode"
    [ppCurrencyName]="currencyName"
    [ppFieldValue]="'' + (ppCustomFields()[ppFieldId()] ? ppCustomFields()[ppFieldId()] : '')"
    [ppNew]="false"
    [ppDecimalPlaces]="2"
    (ppUpdate)="updateCost($event, ppCustomField())"
    [ppIsLocked]="ppCustomField().lockedValue"
  ></pp-custom-field-cost>
</div>
